import { render, staticRenderFns } from "./PwaInstallBanner.vue?vue&type=template&id=ae9cbdf0&scoped=true"
import script from "./PwaInstallBanner.vue?vue&type=script&lang=js"
export * from "./PwaInstallBanner.vue?vue&type=script&lang=js"
import style0 from "./PwaInstallBanner.vue?vue&type=style&index=0&id=ae9cbdf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9cbdf0",
  null
  
)

export default component.exports